// extracted by mini-css-extract-plugin
export default {"nsp_subscription_cancellation_result_description":"SubscriptionCancellationResultPage_nsp_subscription_cancellation_result_description__qqTKq"};